<template>
    <div
        v-if="preFooter"
        :data-theme="colorTheme"
        :data-mode="mode"
        class="relative py-24 surface-background"
    >
        <template v-if="preFooter.preFooter_Image?.length">
            <Image
                class="!absolute inset-0"
                :image="preFooter.preFooter_Image"
            />

            <!-- overlay -->
            <div class="absolute inset-0 z-10" :class="`overlay-${preFooter.preFooter_Overlay}`" />
        </template>

        <div class="relative z-20 container-extra-wide mx-auto px-4 lg:px-6">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                <div class="flex-1 max-w-[620px] space-y-4">
                    <small class="text-subheading uppercase text-base leading-base font-semibold font-ux">
                        {{preFooter.preFooter_Subheading}}
                    </small>

                    <h2 class="text-5xl leading-5xl font-semibold text-heading font-brand-primary">
                        {{preFooter.preFooter_Heading}}
                    </h2>
                </div>

                <div class="mt-4 lg:mt-0 flex-1 lg:max-w-[320px] divide-y divide-[--border-strong]">
                    <NuxtLink
                        v-for="(link, linkIndex) in preFooter.preFooter_Links"
                        :key="linkIndex"
                        :target="link.target"
                        :title="link.title"
                        :to="link.url"
                        class="group py-4 flex items-center"
                    >
                        <div class="flex items-center space-x-3 flex-1">
                            <DIcon
                                v-if="link.icon && link.icon.name"
                                :icon="link.icon.name"
                                :icon-set="link.icon.set"
                                :type="link.icon.type"
                                class="shape-brand-accent"
                            />

                            <p class="font-semibold text-lg leading-lg font-lead text-neutral-extra-strong group-hover:underline underline-offset-4">
                                {{ link.text }}
                            </p>
                        </div>

                        <DIcon
                            class="ml-auto text-neutral-strong group-hover:text-neutral-extra-strong transition-colors duration-150"
                            icon="arrow-right"
                            icon-set="ph"
                        />
                    </NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { DIcon } from '@digistorm/spark'

    const props = defineProps({
        preFooter: Object
    })

    const colorTheme = computed(() => {
        return get(props.preFooter, 'preFooter_ColorTheme')
    })

    const mode = computed(() => {
        const preFooterMode = get(props.preFooter, 'preFooter_ColorPalette')
        if (isEmpty(preFooterMode)) {
            return 'color-invert'
        }
        return preFooterMode
    })
</script>

<style lang="scss" scoped>

    .overlay-brand {
        background: linear-gradient(0deg, rgb(0,0,0,.4) 0%, rgb(0,0,0,.4) 100%), linear-gradient(0deg, var(--overlay-brand-base) 0%, var(--overlay-brand-base) 100%);
    }

    .overlay-neutral {
        @apply bg-overlay-black-60;
    }

    .overlay-neutral-subtle {
        @apply bg-overlay-black-40;
    }
</style>


